<template>
    <v-container fluid class="white px-0 elevation-4">
        <main-app-bar :title="title">
            <template v-slot:buttons>
                <v-btn v-if="isApprovePermission && type !== 'create'" class="mr-4" color="red" dark
                       @click="deleteBtnHandler" :loading="pageLoading" :disabled="pageLoading">Delete
                </v-btn>
                <v-btn class="mx-4" @click="$router.push({ name: 'stockOrders' })">Cancel</v-btn>
                <v-btn color="primary" @click="submitForm" :loading="pageLoading"
                       :disabled="submitBtnDisabled || error !== '' || pageLoading">Save
                </v-btn>
            </template>
        </main-app-bar>
        <v-form ref="mainForm" v-if="!pageLoading && error === ''">
            <v-row class="d-flex align-center justify-space-between px-5" no-gutters>
                <v-col cols="4">
                    <v-radio-group
                        v-model="orderStatus"
                        readonly
                    >
                        <div class="d-flex flex-wrap">
                            <div v-for="status in stockOrderStatuses" :key="status.key" class="mb-2"
                                 style="flex-basis: 50%;" @click="changeStatusHandler(status.value, status.disabled)"
                                 :disabled="status.disabled">
                                <v-radio :value="status.value" :label="status.value" :disabled="status.disabled">
                                </v-radio>
                            </div>
                        </div>
                    </v-radio-group>
                </v-col>
                <v-col cols="5" class="d-flex justify-end">
                    <div class="d-flex justify-space-between">
                        <div>
                            Remaining Monthly <br/>
                            Budget, &#163; {{ remainingMonthlyBudget | thousandsSeparatorAmount }} (inc. VAT)
                        </div>
                        <div :class="totalAmount > remainingMonthlyBudget ? 'red--text' : ''" class="ml-5">
                            <b>Total: &#163; {{ totalAmount.toFixed(2) }} (inc. VAT)</b>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-simple-table class="order-template-table">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th></th>
                        <th class="text-left">Product</th>
                        <th class="text-center">Supplier</th>
                        <th class="text-center">Code</th>
                        <th class="text-center">Base</th>
                        <th class="text-center">In Stock</th>
                        <th class="text-center">To order</th>
                        <th class="text-center">Price, &#163; (inc. VAT)</th>
                        <th class="text-center">Amount, &#163; (inc. VAT)</th>
                        <th class="text-center">Comment</th>
                    </tr>
                    </thead>
                    <tbody v-if="sortedGroups.length">
                    <template v-for="(sortedGroup, index) in sortedGroups">
                        <tr :key="'group-' + index">
                            <td colspan="10" style="text-align: left"><h4>List {{ sortedGroup.sortedNumber }}</h4></td>
                        </tr>
                        <template v-for="(sortedLetter, letterIndex) in sortedGroup.sortedLetters">
                            <tr :key="'group-letter-' + index + letterIndex">
                                <td colspan="10" style="text-align: left; padding-left: 70px;"><h4>{{
                                        sortedLetter
                                    }}</h4></td>
                            </tr>
                            <tr v-for="(product) in baseProducts" :key="'products-' + product.id + letterIndex + index">
                                <template
                                    v-if="product.groupNumber === sortedGroup.sortedNumber && product.groupLetter === sortedLetter">
                                    <td style="width: 30px;" class="px-2">
                                        <div v-if="inReview && isApprovePermission">
                                            <v-btn icon @click="markProduct(product)">
                                                <v-icon dark :color="product.flag ? '#ff3030' : 'black'">mdi-information
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                        <div v-else-if="product.flag">
                                            <v-icon dark color="#ff3030">mdi-flag</v-icon>
                                        </div>
                                    </td>
                                    <td class="py-2 text-left">
                                        <b>{{ product.title }}</b>
                                    </td>
                                    <td>
                                        <stock-table-field :disabled="true" :simpleText="isAllDisabled"
                                                           v-model="product.supplier"
                                                           :error="product.errors.supplier"></stock-table-field>
                                    </td>
                                    <td>
                                        <stock-table-field :disabled="true" :simpleText="isAllDisabled"
                                                           v-model="product.code"
                                                           :error="product.errors.code"></stock-table-field>
                                    </td>
                                    <td><b>{{ product.base }}</b></td>
                                    <td>
                                        <stock-table-field :simpleText="isAllDisabled" type="number"
                                                           @input="toOrderFieldCalculate(product)"
                                                           v-model="product.inStock"
                                                           :error="product.errors.inStock"></stock-table-field>
                                    </td>
                                    <td>
                                        <stock-table-field :simpleText="isAllDisabled" type="number"
                                                           :class="checkToOrderValue(product) ? 'toOrderWarning' : ''"
                                                           @input="calculateAmount(product)" v-model="product.toOrder"
                                                           :error="product.errors.toOrder"></stock-table-field>
                                    </td>
                                    <td>
                                        <stock-table-field :disabled="true" :simpleText="isAllDisabled"
                                                           v-model="product.price"
                                                           :error="product.errors.price"></stock-table-field>
                                    </td>
                                    <td> {{ calculateAmount(product) }}</td>
                                    <td>
                                        <v-icon @click="openComment(product)"
                                                :class="product.comment && product.comment !== '' ? 'existComment' : 'emptyComment'">
                                            $comment
                                        </v-icon>
                                    </td>
                                </template>
                            </tr>
                            <!--<tr :key="`${product.id}-error`" v-if="product.errors.length">
                                <td colspan="9" class="text-left">
                                    <div v-for="error in product.errors" :key="error">
                                        {{error}}
                                    </div>
                                </td>
                            </tr>-->
                        </template>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr v-for="(product) in baseProducts" :key="'products-' + product.id">
                        <td style="width: 30px;" class="px-2">
                            <div v-if="inReview && isApprovePermission">
                                <v-btn icon @click="markProduct(product)">
                                    <v-icon dark :color="product.flag ? '#ff3030' : 'black'">mdi-information
                                    </v-icon>
                                </v-btn>
                            </div>
                            <div v-else-if="product.flag">
                                <v-icon dark color="#ff3030">mdi-flag</v-icon>
                            </div>
                        </td>
                        <td class="py-2 text-left">
                            <b>{{ product.title }}</b>
                        </td>
                        <td>
                            <stock-table-field :disabled="true" :simpleText="isAllDisabled"
                                               v-model="product.supplier"
                                               :error="product.errors.supplier"></stock-table-field>
                        </td>
                        <td>
                            <stock-table-field :disabled="true" :simpleText="isAllDisabled" v-model="product.code"
                                               :error="product.errors.code"></stock-table-field>
                        </td>
                        <td><b>{{ product.base }}</b></td>
                        <td>
                            <stock-table-field :simpleText="isAllDisabled" type="number"
                                               @input="toOrderFieldCalculate(product)" v-model="product.inStock"
                                               :error="product.errors.inStock"></stock-table-field>
                        </td>
                        <td>
                            <stock-table-field :simpleText="isAllDisabled" type="number"
                                               :class="checkToOrderValue(product) ? 'toOrderWarning' : ''"
                                               @input="calculateAmount(product)" v-model="product.toOrder"
                                               :error="product.errors.toOrder"></stock-table-field>
                        </td>
                        <td>
                            <stock-table-field :disabled="true" :simpleText="isAllDisabled" v-model="product.price"
                                               :error="product.errors.price"></stock-table-field>
                        </td>
                        <td> {{ calculateAmount(product) }}</td>
                        <td>
                            <v-icon @click="openComment(product)"
                                    :class="product.comment && product.comment !== '' ? 'existComment' : 'emptyComment'">
                                $comment
                            </v-icon>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-flex v-if="orderProducts.length">
                <h2 class="text-center pa-5">Add custom items</h2>
                <v-simple-table class="order-template-table">
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">Product<span class="required"></span></th>
                            <th class="text-center">Supplier</th>
                            <th class="text-center">Code</th>
                            <th class="text-center">To order<span class="required"></span></th>
                            <th class="text-center">Price, &#163; (inc. VAT)<span class="required"></span></th>
                            <th class="text-left"></th>
                            <th class="text-left"></th>
                            <th class="text-left"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in orderProducts" :key="product.id">
                            <td class="py-2">
                                <v-text-field v-model="product.title" solo dense></v-text-field>
                            </td>
                            <td>
                                <v-text-field v-model="product.supplier" solo dense></v-text-field>
                            </td>
                            <td>
                                <v-text-field v-model="product.code" solo dense></v-text-field>
                            </td>
                            <td>
                                <v-text-field type="number" min="0" v-model="product.toOrder" solo dense></v-text-field>
                            </td>
                            <td>
                                <v-text-field type="number" min="0" v-model="product.price" solo dense></v-text-field>
                            </td>
                            <td> {{ calculateAmount(product) }}</td>
                            <td class="py-2">
                                <v-btn icon fab small
                                       @click="removeProduct(product.tempId || product.id, product.tempId ? 'tempId' : 'id')">
                                    <v-icon>$delete</v-icon>
                                </v-btn>
                            </td>
                            <td>
                                <v-icon @click="openComment(product)"
                                        :class="product.comment && product.comment !== '' ? 'existComment' : 'emptyComment'">
                                    $comment
                                </v-icon>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-flex>
            <div v-else class="text-center pa-5">
                <h3>No added products!</h3>
            </div>
            <div class="ma-4 text-center">
                <v-btn color="primary" @click="addNewProduct">
                    <v-icon small>$plus</v-icon>
                    Add
                </v-btn>
            </div>
        </v-form>
        <h3 v-if="!pageLoading && error.length" class="text-center">{{ error }}</h3>
        <v-skeleton-loader v-if="pageLoading" type="table"></v-skeleton-loader>
        <stock-order-comment @closeModal="closeCommentModal" :isOpen="commentPopup" :product="activeProductComment"/>
    </v-container>
</template>

<script>
import MainAppBar from '@/components/MainAppBar'
import StockTableField from './components/StockTableField'
import { redirect, stockSortingBySublists } from '@/common/functions'
import stockOrderStatusTypes from '@/constatns/stockOrderStatusTypes'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import StockOrderComment from './components/StockOrderComment'

const tableFields = [
    {
        title: 'Product',
        key: 'title',
        type: 'string'
    },
    {
        title: 'Supplier',
        key: 'supplier',
        type: 'string'
    },
    {
        title: 'Code',
        key: 'code',
        type: 'string'
    },
    {
        title: 'Base',
        key: 'base',
        type: 'string'
    },
    {
        title: 'In stock',
        key: 'inStock',
        type: 'number'
    },
    {
        title: 'To order',
        key: 'toOrder',
        type: 'number'
    },
    {
        title: 'Price',
        key: 'price',
        type: 'number'
    }
]

export default {
    props: ['type', 'id', 'orderType'],
    components: {
        MainAppBar,
        StockTableField,
        StockOrderComment
    },
    data: () => ({
        pageLoading: false,
        title: '',
        orderInfo: {},
        orderId: null,
        lastOrderStatus: stockOrderStatusTypes.DRAFT,
        orderStatus: stockOrderStatusTypes.DRAFT,
        orderStatusLoading: false,
        orderProducts: [],
        baseProducts: [],
        remainingMonthlyBudget: null,
        error: '',
        sortedGroups: [],
        commentPopup: false,
        activeProductComment: null
    }),
    computed: {
        ...mapGetters({
            userClinicId: 'getUserActiveClinic'
        }),
        isAllDisabled () {
            return this.orderStatus !== stockOrderStatusTypes.DRAFT
        },
        totalAmount () {
            const baseSum = this.baseProducts.reduce((sum, product) => {
                if (Number(product.price) && Number(product.toOrder)) {
                    const amount = product.price * product.toOrder
                    sum += amount
                }

                return sum
            }, 0)
            if (this.orderProducts.length) {
                return this.orderProducts.reduce((sum, product) => {
                    if (Number(product.price) && Number(product.toOrder)) {
                        const amount = product.price * product.toOrder
                        sum += amount
                    }
                    return sum
                }, baseSum)
            } else {
                return baseSum
            }
        },
        inReview () {
            return this.orderStatus === stockOrderStatusTypes.REVIEW
        },
        isApprovePermission () {
            return this.$store.getters.getAllUserPermissions.includes(157)
        },
        stockOrderStatuses () {
            const statuses = []
            for (const [key, value] of Object.entries(stockOrderStatusTypes)) {
                const status = {
                    key,
                    value
                }

                if (this.type === 'create') {
                    if (value !== stockOrderStatusTypes.DRAFT) {
                        status.disabled = true
                    }
                } else {
                    if (value === stockOrderStatusTypes.APPROVED && !this.isApprovePermission) {
                        status.disabled = true
                    }

                    if (value === stockOrderStatusTypes.COMPLETED && !this.isApprovePermission) {
                        if (this.orderStatus !== stockOrderStatusTypes.APPROVED) {
                            status.disabled = true
                        }
                    }

                    if (this.orderStatus === stockOrderStatusTypes.REVIEW && !this.isApprovePermission) {
                        if (value === stockOrderStatusTypes.REVIEW ||
                            value === stockOrderStatusTypes.COMPLETED) {
                            status.disabled = true
                        }
                    }

                    if (this.orderStatus === stockOrderStatusTypes.COMPLETED &&
                        !this.isApprovePermission) {
                        status.disabled = true
                    }

                    if (value === stockOrderStatusTypes.COMPLETED &&
                        this.remainingMonthlyBudget < this.totalAmount &&
                        !this.isApprovePermission) {
                        status.disabled = true
                    }
                }

                statuses.push(status)
            }
            return statuses
        },
        submitBtnDisabled () {
            return !(this.orderStatus === stockOrderStatusTypes.DRAFT)
        }
    },
    filters: {
        thousandsSeparatorAmount (val) {
            if (val && typeof val === 'number') {
                return val.toLocaleString()
            }
            return 0
        }
    },
    watch: {
        type () {
            this.onMounted()
        },
        userClinicId () {
            this.$router.push({ name: 'stockOrders' })
        }
    },
    methods: {
        ...mapActions(['fetchOrderTemplate', 'createOrder', 'fetchOrderInfo', 'changeOrderStatus', 'createOrder', 'updateOrder', 'markOrderProducts', 'deleteOrder', 'showAlert']),
        createPayload () {
            return {
                orderType: this.$router.currentRoute.params.orderType,
                id: this.orderId,
                clinicId: this.userClinicId,
                baseProducts: this.baseProducts.concat(),
                products: this.orderProducts.concat()
            }
        },
        toOrderFieldCalculate (product) {
            product.toOrder = product.base - product.inStock | this.thousandsSeparatorAmount
        },
        calculateAmount (product) {
            product.amount = product.price * product.toOrder
            if (Math.sign(product.toOrder) === -1) {
                product.toOrder = 0
            }
            return product.amount.toFixed(2)
        },
        async changeStatusHandler (val, isDisabled) {
            if (this.type === 'create' || isDisabled) return

            const confirmModalOptions = {
                text: 'Save order and update the status?',
                agreeBtnText: 'SAVE & UPDATE',
                type: 'info'
            }
            const confirm = await this.$root.$confirmDialog.open('', confirmModalOptions)

            if (!confirm) {
                return
            }

            if (this.validate(this.baseProducts)) {
                this.pageLoading = true
                if (this.orderStatus === stockOrderStatusTypes.DRAFT) {
                    const payload = this.createPayload()
                    await this.updateOrder(payload)
                }
                this.orderStatus = val
                await this.changeOrderStatus({
                    id: this.orderId,
                    status: val
                })
                this.showAlert({
                    type: 'success',
                    text: 'Successfully updated!'
                })
                this.pageLoading = false
            } else {
                this.showAlert({
                    type: 'error',
                    text: 'Please check form on errors'
                })
            }
        },
        async markProduct (product) {
            product.flag = !product.flag
            const products = this.baseProducts.concat()
            const payload = {
                id: this.orderId,
                clinicId: this.userClinicId,
                products: products.map(({ id, flag }) => ({
                    id,
                    flag
                }))
            }
            this.pageLoading = true
            await this.markOrderProducts(payload)
            this.pageLoading = false
        },
        async deleteBtnHandler () {
            if (await this.$root.$confirmDialog.open(this.orderInfo.title)) {
                this.pageLoading = true
                await this.deleteOrder(this.orderId)
                this.pageLoading = false
            }
        },
        validate (products) {
            let isValid = true

            products.forEach(product => {
                product.errors = []
                tableFields.forEach(({ key, title, type }) => {
                    const value = product[key]

                    if (type === 'string' && (!value || !String(value).length)) {
                        product.errors[key] = `${title} field is required`
                    }

                    if (type === 'number' && (isNaN(Number(value)) || Number(value) < 0)) {
                        product.errors[key] = `${title} field must be a positive number or empty!`
                    }
                })

                if (Object.entries(product.errors).length) {
                    isValid = false
                }
            })

            if (this.orderProducts.length) {
                this.orderProducts.forEach(product => {
                    if (!product.title || !product.toOrder || !product.price || Math.sign(product.toOrder) === -1 || Math.sign(product.price) === -1) {
                        isValid = false
                    }
                })
            }

            return isValid
        },
        checkToOrderValue (item) {
            const maxOrder = item.base - item.inStock
            if (maxOrder < item.toOrder) {
                return true
            }
        },
        async submitForm () {
            const isValid = this.validate(this.baseProducts)

            if (!isValid) {
                this.showAlert({
                    type: 'error',
                    text: 'Please check form on errors'
                })
                return
            }
            const payload = this.createPayload()
            this.pageLoading = true
            try {
                if (this.type === 'create') {
                    delete payload.id
                    await this.createOrder(payload)
                    this.pageLoading = false
                } else if (this.type === 'edit') {
                    await this.updateOrder(payload)
                    this.pageLoading = false
                    this.showAlert({
                        type: 'success',
                        text: 'Successfully updated!'
                    })
                    redirect('stockOrders')
                }
            } catch (e) {
                this.$store.dispatch('showAlert', {
                    type: 'error',
                    text: 'Server error occurred!'
                })
            }
        },
        sortProducts () {
            this.baseProducts.sort(stockSortingBySublists)
            this.baseProducts.forEach(product => {
                const sortedItem = this.sortedGroups.find(item => product.groupNumber === item.sortedNumber)
                if (!sortedItem) {
                    const sortedValue = {
                        sortedNumber: product.groupNumber,
                        sortedLetters: []
                    }
                    if (!sortedValue.sortedLetters.find(item => product.groupLetter === item)) {
                        sortedValue.sortedLetters.push(product.groupLetter)
                    }
                    this.sortedGroups.push(sortedValue)
                } else {
                    if (!sortedItem.sortedLetters.find(item => product.groupLetter === item)) {
                        sortedItem.sortedLetters.push(product.groupLetter)
                    }
                }
            })
        },
        async getOrderTemplate () {
            this.pageLoading = true
            this.error = ''
            this.monthlyBudget = null
            this.orderProducts = []
            if (!this.userClinicId) {
                return
            }
            const params = {
                orderType: this.$router.currentRoute.params.orderType,
                groupId: this.$store.getters.getUserActiveGroup,
                clinicId: this.userClinicId
            }
            const result = await this.fetchOrderTemplate(params) || {}
            this.pageLoading = false
            if (!Object.keys(result).length) {
                this.error = 'There is no order template in this clinic'
                return
            }
            this.monthlyBudget = result.monthlyBudget || ''
            this.remainingMonthlyBudget = result.remainingMonthly || ''
            this.baseProducts = result.products && result.products.length ? this.setProductsByDefault(result.products.filter(item => !item.isDisabled)) : []
            this.sortProducts()
            const noBaseProducts = this.baseProducts.filter(item => !item.base)
            if (noBaseProducts.length) {
                this.error = 'This order template is outdated. Please contact your manager to update it'
            }
        },
        async getOrderInfo (orderId) {
            this.pageLoading = true
            this.monthlyBudget = null
            this.orderProducts = []
            if (!this.userClinicId) {
                return
            }
            const result = await this.fetchOrderInfo(orderId) || {}
            this.pageLoading = false
            this.title += ' - ' + result.title
            this.orderInfo = result
            if (result.products) {
                this.orderProducts = result.products.filter(item => !item.isBasedOnTemplateProduct) || []
                this.baseProducts = this.setProducts(result.products.filter(item => item.isBasedOnTemplateProduct)) || []
            }
            this.sortProducts()
            this.remainingMonthlyBudget = result.remainingMonthly || 0
            this.orderStatus = result.status
        },
        setProductsByDefault (products) {
            return products.map(product => {
                Vue.set(product, 'errors', {})
                Vue.set(product, 'amount', 0)
                Vue.set(product, 'inStock', product.base)
                Vue.set(product, 'toOrder', 0)
                Vue.set(product, 'comment', '')

                return product
            })
        },
        setProducts (products) {
            return products.map(product => {
                Vue.set(product, 'errors', {})
                return product
            })
        },
        addNewProduct () {
            const product = {
                tempId: this.$uuid.v4(),
                title: '',
                base: '',
                price: 0,
                toOrder: 0
            }
            this.orderProducts.push(product)
        },
        removeProduct (productId, type) {
            if (type === 'id') {
                this.orderProducts = this.orderProducts.filter(({ id }) => id !== productId)
            } else {
                this.orderProducts = this.orderProducts.filter(({ tempId }) => tempId !== productId)
            }
        },
        onMounted () {
            if (this.type === 'create') {
                this.title = 'Create order'
                this.getOrderTemplate()
            } else if (this.type === 'edit') {
                this.title = 'Edit Order'
                this.orderId = Number(this.$router.currentRoute.params.id)
                this.getOrderInfo(this.orderId)
            }
        },
        openComment (product) {
            this.commentPopup = true
            this.activeProductComment = product
        },
        closeCommentModal () {
            this.commentPopup = false
            this.activeProductComment = {}
        }
    },
    async mounted () {
        this.onMounted()
    }
}
</script>

<style lang="scss">
.order-template-table {
    tbody {
        td {
            text-align: center;
            padding-top: 5px;
            padding-bottom: 5px;
            max-width: 100px;
        }
    }
}

.required {
    color: red;
}

.emptyComment, .existComment {
    cursor: pointer;
}

.emptyComment .commentStyle {
    stroke: #000;
    fill: #fff;
}

.existComment .commentStyle {
    fill: #6c9d39;
}

.toOrderWarning {
    color: red;
}

.toOrderWarning .v-input__slot {
    border: 1px solid red;
}
</style>
